import { render, staticRenderFns } from "./DialogCreateNickname.vue?vue&type=template&id=086e244d&scoped=true"
import script from "./DialogCreateNickname.js?vue&type=script&lang=js&external"
export * from "./DialogCreateNickname.js?vue&type=script&lang=js&external"
import style0 from "./DialogCreateNickname.vue?vue&type=style&index=0&id=086e244d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086e244d",
  null
  
)

export default component.exports